import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastmessageService } from 'src/app/toastmessage.service';
import { MessService } from '../mess.service';
import { ColDef, GridApi, GridReadyEvent } from 'ag-grid-community';
import { Workbook } from 'exceljs';
import * as fs from 'file-saver';
import { ConfirmationMessageDialogComponent } from '../confirmation-message-dialog/confirmation-message-dialog.component';

@Component({
  selector: 'app-mess-excel',
  templateUrl: './mess-excel.component.html',
  styleUrls: ['./mess-excel.component.scss']
})
export class MessExcelComponent implements OnInit {

  messBuildingId: any;
  daysheetDate: any;
  messBuildingName = '';
  inventroyData: any;

  inventoryGridApi!: GridApi;
  supplyGridApi!: GridApi;

  inventoryRowData: any[] = [];
  supplyRowData: any[] = [];
  scenarioBasedMenuItemsList: any[] = [];

  /** Expand/collapse state per scenario (Breakfast expanded by default). */
  scenarioExpanded: Record<string, boolean> = {};

  /** View toggle: All (Today's Menu + merged table) | Summary (per-scenario boxes). */
  summaryViewMode: 'all' | 'summary' = 'all';
  allSummaryRows: any[] = [];
  allSummaryTotalCost = 0;

  /** Institution title shown beside the logo in the exported Excel header. */
  private readonly excelInstitutionTitle = 'Sri Chaitanya Educational Institutions';
  private readonly excelLogoPath = 'assets/image/favicon.ico';

  defaultColDef: ColDef = {
    flex: 1,
    sortable: true,
    filter: true,
    resizable: true,
    
  };

  supplyDefaultColDef: ColDef = {
    flex: 1,
    sortable: true,
    filter: false,
    resizable: true,
    menuTabs: [],
    suppressHeaderMenuButton: true,
  };

  inventoryColDefs: ColDef[] = [
    { headerName: 'S.No', width: 80, valueGetter: (p: any) => (p.node?.rowIndex ?? 0) + 1 },
    { field: 'itemName', headerName: 'Item Name', minWidth: 280 },
    { field: 'onHandQty', headerName: 'Open Balance', width: 140, valueFormatter: (p) => this.inrGroupedNumber(p.value) },
    { field: 'bfQty', headerName: 'Breakfast Qty', width: 140, valueFormatter: (p) => this.inrGroupedNumber(p.value) },
    { field: 'lunchQty', headerName: 'Lunch Qty', width: 120, valueFormatter: (p) => this.inrGroupedNumber(p.value) },
    { field: 'snacksQty', headerName: 'Snacks Qty', width: 120, valueFormatter: (p) => this.inrGroupedNumber(p.value) },
    { field: 'dinnerQty', headerName: 'Dinner Qty', width: 120, valueFormatter: (p) => this.inrGroupedNumber(p.value) },
    { field: 'totalQty', headerName: 'Total Qty', width: 110, valueFormatter: (p) => this.inrGroupedNumber(p.value) },
    { field: 'ratePerUnit', headerName: 'Rate', width: 110, valueFormatter: (p) => this.inrGroupedNumber(p.value) },
    { field: 'itemFusionId', headerName: 'Fusion Id', width: 140 },
  ];

  supplyColDefs: ColDef[] = [
    { headerName: 'S.No', filter: false, width: 80, minWidth: 80, maxWidth: 100, cellStyle: { textAlign: 'center' }, valueGetter: (p: any) => (p.node?.rowIndex ?? 0) + 1 },
    { field: 'supplyBuildingName', headerName: 'Campus', filter: false, width: 450, minWidth: 450, flex: 0 },
    { field: 'studentCount', headerName: 'Students', filter: false ,cellStyle: { textAlign: 'right' }},
    { field: 'employeeCount', headerName: 'Employees', filter: false ,cellStyle: { textAlign: 'right' }},
    { field: 'subStaffCount', headerName: 'SubStaff', filter: false,cellStyle: { textAlign: 'right' } },
    { field: 'visitorsCount', headerName: 'Others', filter: false ,cellStyle: { textAlign: 'right' }},
  ];

  constructor(
    private route: ActivatedRoute,
    private service: MessService,
    private spinner: NgxSpinnerService,
    private toast: ToastmessageService,
    private router: Router,
    private matDialog: MatDialog,
  ) { }

  ngOnInit(): void {
    // Landing shell (MessDetails): params from MessService after closed list → excel setView
    if (this.router.url.includes('MessDetails')) {
      const fromService = this.service.getMessExcelParams();
      if (fromService?.['messBuildingId'] != null && fromService['messBuildingId'] !== '') {
        this.applyExcelParams(fromService);
      }
    }

    // Dedicated /messExcelDetails route: keep existing queryParams behavior
    this.route.queryParams.subscribe(params => {
      if (params?.['messBuildingId'] == null || params['messBuildingId'] === '') {
        return;
      }
      this.applyExcelParams(params);
    });
  }

  private applyExcelParams(params: Record<string, any>): void {
    this.messBuildingId = params['messBuildingId'];
    this.daysheetDate = params['daysheetDate'];
    this.messBuildingName = String(params['messBuildingName'] ?? '').trim();
    console.log('messBuildingId:', this.messBuildingId);
    console.log('daysheetDate:', this.daysheetDate);
    this.getInventoryDetails();
  }

  onInventoryGridReady(e: GridReadyEvent): void {
    this.inventoryGridApi = e.api;
  }

  onSupplyGridReady(e: GridReadyEvent): void {
    this.supplyGridApi = e.api;
  }

  getInventoryDetails(): void {
    this.spinner.show();
    this.service.InventoryDetails(this.messBuildingId, this.daysheetDate).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return;
        }
        this.inventroyData = res;
        this.scenarioBasedMenuItemsList = this.normalizeScenarioBasedMenuItemsList(
          this.getScenarioBasedMenuItemsListFromInventory(res),
        );
        this.inventoryRowData = this.scenarioBasedMenuItemsList.length
          ? this.flattenScenarioInventoryRows(this.scenarioBasedMenuItemsList)
          : Array.isArray(res?.saveInventoryBalanceDetails)
            ? res.saveInventoryBalanceDetails
            : [];
        this.supplyRowData = Array.isArray(res?.supplyBuildings) ? res.supplyBuildings : [];
        this.initScenarioExpanded();
        this.buildAllSummaryRows();
        this.summaryViewMode = 'all';
        console.log('  this.inventroyData', this.inventroyData);
        this.spinner.hide();
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

  private getScenarioBasedMenuItemsListFromInventory(inv: any): any[] {
    const list = inv?.ScenarioBasedMenuItemsList ?? inv?.scenarioBasedMenuItemsList;
    return Array.isArray(list) ? list : [];
  }

  private normalizeScenarioBasedMenuItemsList(rawList: any[]): any[] {
    return (rawList ?? []).map((scenario) => ({
      scenarioId: scenario?.scenarioId,
      scenarioName: String(scenario?.scenarioName ?? '').trim(),
      daysheetMenuItemsList: (Array.isArray(scenario?.daysheetMenuItemsList) ? scenario.daysheetMenuItemsList : []).map(
        (item: any) => ({
          daysheetMenuItemId: item?.DaysheetMenuItemId ?? item?.daysheetMenuItemId,
          daysheetMenuItemName: String(item?.DaysheetMenuItemName ?? item?.daysheetMenuItemName ?? '').trim(),
          status: String(item?.status ?? item?.itemStatus ?? '1'),
        }),
      ),
      saveInventoryBalanceDetails: Array.isArray(scenario?.saveInventoryBalanceDetails)
        ? scenario.saveInventoryBalanceDetails
        : [],
    }));
  }

  private flattenScenarioInventoryRows(scenarios: any[]): any[] {
    return (scenarios ?? []).flatMap((scenario) => scenario?.saveInventoryBalanceDetails ?? []);
  }

  private getScenarioKey(scenario: any): string {
    return String(scenario?.scenarioId ?? scenario?.scenarioName ?? '').trim().toLowerCase();
  }

  private isBreakfastScenario(scenario: any): boolean {
    const name = String(scenario?.scenarioName ?? '').trim().toLowerCase();
    return name.includes('breakfast') || Number(scenario?.scenarioId) === 13;
  }

  private initScenarioExpanded(): void {
    this.scenarioExpanded = {};
    for (const scenario of this.scenarioBasedMenuItemsList) {
      this.scenarioExpanded[this.getScenarioKey(scenario)] = this.isBreakfastScenario(scenario);
    }
  }

  setSummaryViewMode(mode: 'all' | 'summary'): void {
    this.summaryViewMode = mode;
  }

  /** Merge every scenario's inventory rows into one table for the All view. */
  private buildAllSummaryRows(): void {
    const scenarios = this.scenarioBasedMenuItemsList ?? [];
    const merged = new Map<string, any>();

    for (const scenario of scenarios) {
      for (const item of scenario?.saveInventoryBalanceDetails ?? []) {
        const key = String(item?.itemId ?? item?.itemName ?? '').trim();
        if (!key) continue;
        const existing = merged.get(key);
        if (!existing) {
          merged.set(key, {
            ...item,
            bfQty: Number(item?.bfQty ?? 0),
            lunchQty: Number(item?.lunchQty ?? 0),
            snacksQty: Number(item?.snacksQty ?? 0),
            dinnerQty: Number(item?.dinnerQty ?? item?.DinnerQty ?? 0),
          });
        } else {
          existing.bfQty += Number(item?.bfQty ?? 0);
          existing.lunchQty += Number(item?.lunchQty ?? 0);
          existing.snacksQty += Number(item?.snacksQty ?? 0);
          existing.dinnerQty += Number(item?.dinnerQty ?? item?.DinnerQty ?? 0);
        }
      }
    }

    this.allSummaryRows = Array.from(merged.values()).map((row: any) => {
      const totalQty = row.bfQty + row.lunchQty + row.snacksQty + row.dinnerQty;
      const totalCost = Number((totalQty * Number(row?.ratePerUnit ?? 0)).toFixed(2));
      return { ...row, totalQty, totalCost };
    });

    this.allSummaryTotalCost = Number(
      this.allSummaryRows.reduce((sum, row) => sum + Number(row.totalCost ?? 0), 0).toFixed(2),
    );
  }

  /** Today's Menu lines for All view. */
  getTodaysMenuList(): Array<{ scenarioName: string; menuItems: string }> {
    return (this.scenarioBasedMenuItemsList ?? []).map((scenario: any) => ({
      scenarioName: String(scenario?.scenarioName ?? '').trim(),
      menuItems: this.getScenarioMenuLabel(scenario),
    }));
  }

  isScenarioExpanded(scenario: any): boolean {
    return this.scenarioExpanded[this.getScenarioKey(scenario)] ?? false;
  }

  toggleScenarioExpand(scenario: any): void {
    const key = this.getScenarioKey(scenario);
    this.scenarioExpanded[key] = !this.isScenarioExpanded(scenario);
  }

  getActiveScenarioMenuItems(scenario: any): any[] {
    return (scenario?.daysheetMenuItemsList ?? []).filter(
      (item: any) => String(item?.status ?? '1') !== '0',
    );
  }

  getScenarioMenuLabel(scenario: any): string {
    return this.getActiveScenarioMenuItems(scenario)
      .map((item: any) => item.daysheetMenuItemName)
      .filter((name: string) => !!name)
      .join(', ') || '—';
  }

  getScenarioMenuItemCount(scenario: any): number {
    return this.getActiveScenarioMenuItems(scenario).length;
  }

  getScenarioTotalCost(scenario: any): number {
    return (scenario?.saveInventoryBalanceDetails ?? []).reduce(
      (sum: number, item: any) => sum + Number(item?.totalCost ?? 0),
      0,
    );
  }

  getScenarioMealQtyLabel(scenario: any): string {
    const qtyField = this.getScenarioMealQtyField(String(scenario?.scenarioName ?? ''));
    switch (qtyField) {
      case 'bfQty': return 'Breakfast Qty';
      case 'lunchQty': return 'Lunch Qty';
      case 'snacksQty': return 'Snacks Qty';
      default: return 'Dinner Qty';
    }
  }

  getScenarioMealQtyValue(scenario: any, item: any): number {
    const qtyField = this.getScenarioMealQtyField(String(scenario?.scenarioName ?? ''));
    if (qtyField === 'DinnerQty') {
      return Number(item?.dinnerQty ?? item?.DinnerQty ?? 0);
    }
    return Number(item?.[qtyField] ?? 0);
  }

  private getScenarioMealQtyField(scenarioName: string): 'bfQty' | 'lunchQty' | 'snacksQty' | 'DinnerQty' {
    const name = String(scenarioName ?? '').trim().toLowerCase();
    if (name.includes('breakfast')) {
      return 'bfQty';
    }
    if (name.includes('lunch')) {
      return 'lunchQty';
    }
    if (name.includes('snack')) {
      return 'snacksQty';
    }
    if (name.includes('dinner')) {
      return 'DinnerQty';
    }
    return 'bfQty';
  }

  /** Confirm before exporting Excel. */
  onDownloadExcelClick(): void {
    const inventory = Array.isArray(this.inventoryRowData) ? this.inventoryRowData : [];
    const supply = Array.isArray(this.supplyRowData) ? this.supplyRowData : [];
    const scenarios = Array.isArray(this.scenarioBasedMenuItemsList) ? this.scenarioBasedMenuItemsList : [];

    if (!inventory.length && !supply.length && !scenarios.length) {
      this.toast.showError('No data to export.');
      return;
    }

    const confirmRef = this.matDialog.open(ConfirmationMessageDialogComponent, {
      width: '420px',
      disableClose: true,
      data: {
        title: 'Download Excel',
        message: 'Do you want to download the Mess Daysheet Excel file?',
        confirmLabel: 'Download',
        confirmResult: 'download',
      },
    });

    confirmRef.afterClosed().subscribe((result) => {
      if (result === 'download') {
        void this.exportAllToExcel();
      }
    });
  }

  /** Confirm before exporting Fusion-format Excel (ingredient on-hand list). */
  onDownloadFusionExcelClick(): void {
    const rows = this.getFusionExcelRows();
    if (!rows.length) {
      this.toast.showError('No data to export.');
      return;
    }

    const confirmRef = this.matDialog.open(ConfirmationMessageDialogComponent, {
      width: '420px',
      disableClose: true,
      data: {
        title: 'Fusion Excel Download',
        message: 'Do you want to download the Fusion Excel file?',
        confirmLabel: 'Download',
        confirmResult: 'download',
      },
    });

    confirmRef.afterClosed().subscribe((result) => {
      if (result === 'download') {
        void this.exportFusionExcel();
      }
    });
  }

  /** Confirm before exporting Supply Strength Excel (campus headcount sheet). */
  onDownloadSupplyStrengthExcelClick(): void {
    const rows = this.getSupplyStrengthExcelRows();
    if (!rows.length) {
      this.toast.showError('No data to export.');
      return;
    }

    const confirmRef = this.matDialog.open(ConfirmationMessageDialogComponent, {
      width: '420px',
      disableClose: true,
      data: {
        title: 'Supply Strength Excel',
        message: 'Do you want to download the Supply Strength Excel file?',
        confirmLabel: 'Download',
        confirmResult: 'download',
      },
    });

    confirmRef.afterClosed().subscribe((result) => {
      if (result === 'download') {
        void this.exportSupplyStrengthExcel();
      }
    });
  }

  /**
   * Unique inventory rows for Fusion Excel:
   * Ingredient Code, Ingredient, Localized Name, UOM, Onhand Qty.
   * Issue Qty, Unit Price, Line Status, and Error Msg are exported as empty columns.
   */
  private getFusionExcelRows(): Array<{
    itemFusionId: string;
    itemNameEn: string;
    itemNameTe: string;
    uom: string;
    onHandQty: number;
  }> {
    const scenarios = Array.isArray(this.scenarioBasedMenuItemsList) ? this.scenarioBasedMenuItemsList : [];
    const flat = scenarios.length
      ? this.flattenScenarioInventoryRows(scenarios)
      : (Array.isArray(this.inventoryRowData) ? this.inventoryRowData : []);

    const merged = new Map<string, {
      itemFusionId: string;
      itemNameEn: string;
      itemNameTe: string;
      uom: string;
      onHandQty: number;
    }>();

    for (const item of flat) {
      const fusionId = this.cleanExcelText(item?.itemFusionId);
      const key = fusionId || String(item?.itemId ?? item?.itemNameEn ?? item?.itemName ?? '').trim();
      if (!key || merged.has(key)) {
        continue;
      }
      const itemNameEn = this.cleanExcelText(item?.itemNameEn ?? item?.itemName);
      const itemNameTe = this.cleanExcelText(item?.itemNameTe);
      merged.set(key, {
        itemFusionId: fusionId,
        itemNameEn,
        itemNameTe,
        uom: this.extractUom(itemNameEn, itemNameTe, item),
        onHandQty: Number(item?.onHandQty ?? 0),
      });
    }

    return Array.from(merged.values());
  }

  /** Strip invisible/bidi control chars from API item names. */
  private cleanExcelText(value: any): string {
    return String(value ?? '')
      .replace(/[\u200E\u200F\u202A-\u202E\u2066-\u2069]/g, '')
      .trim();
  }

  /** Prefer UOM from item payload; else parse `[kg]` / `[కిలో]` from name. */
  private extractUom(itemNameEn: string, itemNameTe: string, item: any): string {
    const fromApi = this.cleanExcelText(item?.uom ?? item?.UOM ?? item?.unitOfMeasure);
    if (fromApi) {
      return fromApi.toUpperCase();
    }
    const match = `${itemNameEn} ${itemNameTe}`.match(/\[\s*([^\]\u0C00-\u0C7F]+)\s*\]/i);
    if (match?.[1]) {
      const raw = match[1].trim().toUpperCase();
      if (raw === 'KILO' || raw === 'KILOGRAM' || raw === 'KILOGRAMS') {
        return 'KG';
      }
      return raw;
    }
    if (/\[కిలో\]/i.test(itemNameTe) || /\[kg\]/i.test(itemNameEn)) {
      return 'KG';
    }
    return 'KG';
  }

  /** Fusion on-hand Excel matching Ingredient Code / Ingredient / Localized Name / UOM / Onhand Qty / Issue Qty / Unit Price / Line Status / Error Msg. */
  async exportFusionExcel(): Promise<void> {
    const rows = this.getFusionExcelRows();
    if (!rows.length) {
      this.toast.showError('No data to export.');
      return;
    }

    const workbook = new Workbook();
    const ws = workbook.addWorksheet('Fusion On Hand');

    const headers = [
      'Ingredient Code',
      'Ingredient',
      'Localized Name',
      'UOM',
      'Onhand Qty',
      'Issue Qty',
      'Unit Price',
      'Line Status',
      'Error Msg',
    ];
    const headerRow = ws.addRow(headers);
    headerRow.font = { bold: true };
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFF2F2F2' },
      };
      cell.border = {
        top: { style: 'thin' },
        bottom: { style: 'thin' },
        left: { style: 'thin' },
        right: { style: 'thin' },
      };
      cell.alignment = { vertical: 'middle', horizontal: 'left' };
    });

    rows.forEach((row) => {
      const dataRow = ws.addRow([
        row.itemFusionId,
        row.itemNameEn,
        row.itemNameTe,
        row.uom,
        row.onHandQty,
        '',
        '',
        '',
        '',
      ]);
      dataRow.eachCell((cell, colNumber) => {
        cell.border = {
          top: { style: 'thin' },
          bottom: { style: 'thin' },
          left: { style: 'thin' },
          right: { style: 'thin' },
        };
        cell.alignment = {
          vertical: 'middle',
          horizontal: colNumber === 5 ? 'right' : 'left',
        };
      });
    });

    ws.columns = [
      { width: 18 },
      { width: 45 },
      { width: 35 },
      { width: 10 },
      { width: 14 },
      { width: 14 },
      { width: 14 },
      { width: 16 },
      { width: 30 },
    ];

    ws.autoFilter = {
      from: { row: 1, column: 1 },
      to: { row: 1, column: headers.length },
    };
    ws.views = [{ state: 'frozen', ySplit: 1 }];

    await this.protectExcelSheetReadOnly(ws);

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const fileName = `FusionOnHand_${String(this.daysheetDate ?? '').replace(/\s+/g, '_') || 'export'}.xlsx`;
      fs.saveAs(blob, fileName);
    }).catch(() => {
      this.toast.showError('Fusion Excel export failed.');
    });
  }

  /** Campus Code as `CODE - NAME` when a code is present. */
  private formatSupplyCampusCode(row: any): string {
    const name = this.cleanExcelText(
      row?.supplyBuildingName ?? row?.campusName ?? row?.buildingName ?? '',
    );
    const code = this.cleanExcelText(
      row?.campusCode ??
      row?.subInventoryCode ??
      row?.supplyBuildingCode ??
      row?.buildingCode ??
      row?.code ??
      '',
    );
    if (code && name) {
      if (name.toUpperCase().startsWith(code.toUpperCase())) {
        return name;
      }
      return `${code} - ${name}`;
    }
    return code || name;
  }

  private getSupplyStrengthExcelRows(): Array<{
    campusCode: string;
    students: number;
    employees: number;
    visitors: number;
    totalCount: number;
  }> {
    const supply = Array.isArray(this.supplyRowData) ? this.supplyRowData : [];
    return supply.map((row: any) => {
      const students = Number(row?.studentCount ?? 0) || 0;
      const employees =
        (Number(row?.employeeCount ?? 0) || 0) + (Number(row?.subStaffCount ?? 0) || 0);
      const visitors = Number(row?.visitorsCount ?? 0) || 0;
      return {
        campusCode: this.formatSupplyCampusCode(row),
        students,
        employees,
        visitors,
        totalCount: students + employees + visitors,
      };
    }).filter((row) => !!row.campusCode);
  }

  /** Supply Strength Excel: Campus Code, Students, Employees, Visitors, Total Count. */
  async exportSupplyStrengthExcel(): Promise<void> {
    const rows = this.getSupplyStrengthExcelRows();
    if (!rows.length) {
      this.toast.showError('No data to export.');
      return;
    }

    const workbook = new Workbook();
    const ws = workbook.addWorksheet('Supply Strength');

    const headers = ['Campus Code', 'Students', 'Employees', 'Visitors', 'Total Count'];
    const headerRow = ws.addRow(headers);
    headerRow.font = { bold: true };
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFF2F2F2' },
      };
      cell.border = {
        top: { style: 'thin' },
        bottom: { style: 'thin' },
        left: { style: 'thin' },
        right: { style: 'thin' },
      };
      cell.alignment = { vertical: 'middle', horizontal: 'left' };
    });

    rows.forEach((row) => {
      const dataRow = ws.addRow([
        row.campusCode,
        row.students || '',
        row.employees || '',
        row.visitors || '',
        row.totalCount,
      ]);
      dataRow.eachCell((cell, colNumber) => {
        cell.border = {
          top: { style: 'thin' },
          bottom: { style: 'thin' },
          left: { style: 'thin' },
          right: { style: 'thin' },
        };
        cell.alignment = {
          vertical: 'middle',
          horizontal: colNumber === 1 ? 'left' : 'right',
        };
      });
    });

    ws.columns = [
      { width: 55 },
      { width: 14 },
      { width: 14 },
      { width: 14 },
      { width: 14 },
    ];

    ws.autoFilter = {
      from: { row: 1, column: 1 },
      to: { row: 1, column: headers.length },
    };
    ws.views = [{ state: 'frozen', ySplit: 1 }];

    await this.protectExcelSheetReadOnly(ws);

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const fileName = `SupplyStrength_${String(this.daysheetDate ?? '').replace(/\s+/g, '_') || 'export'}.xlsx`;
      fs.saveAs(blob, fileName);
    }).catch(() => {
      this.toast.showError('Supply Strength Excel export failed.');
    });
  }

  async exportAllToExcel(): Promise<void> {
    const inv = this.inventroyData ?? {};
    const inventory = Array.isArray(this.inventoryRowData) ? this.inventoryRowData : [];
    const supply = Array.isArray(this.supplyRowData) ? this.supplyRowData : [];
    const scenarios = Array.isArray(this.scenarioBasedMenuItemsList) ? this.scenarioBasedMenuItemsList : [];

    if (!inventory.length && !supply.length && !scenarios.length) {
      this.toast.showError('No data to export.');
      return;
    }

    const workbook = new Workbook();
    const ws = workbook.addWorksheet('Mess Daysheet');

    const yellowFill = {
      type: 'pattern' as const,
      pattern: 'solid' as const,
      fgColor: { argb: 'FFFF00' },
    };

    const applyYellow = (r: number, c: number) => {
      const cell = ws.getCell(r, c);
      cell.fill = yellowFill as any;
      cell.alignment = { vertical: 'middle', horizontal: 'left' } as any;
    };

    const applyBorder = (row: any) => {
      row.eachCell((cell: any) => {
        cell.border = {
          top: { style: 'thin' },
          bottom: { style: 'thin' },
          left: { style: 'thin' },
          right: { style: 'thin' },
        };
        cell.alignment = { vertical: 'middle' };
      });
    };

    // Institution header: logo (left) + title (side by side)
    ws.mergeCells(1, 2, 3, 10);
    const instCell = ws.getCell(1, 2);
    instCell.value = this.excelInstitutionTitle;
    instCell.font = { size: 16, bold: true, color: { argb: 'FF0B3F78' } };
    instCell.alignment = { vertical: 'middle', horizontal: 'left' };
    ws.getRow(1).height = 22;
    ws.getRow(2).height = 22;
    ws.getRow(3).height = 22;
    await this.addExcelLogo(workbook, ws);

    ws.mergeCells(5, 1, 5, 10);
    ws.getCell(5, 1).value = 'Mess Daysheet Closed';
    ws.getCell(5, 1).font = { size: 14, bold: true };
    ws.getRow(5).height = 22;
    for (let c = 1; c <= 10; c++) applyYellow(5, c);

    const buildingName = String(this.messBuildingName ?? '').trim();
    ws.mergeCells(6, 1, 6, 10);
    ws.getCell(6, 1).value = buildingName ? `Building Name: ${buildingName}` : '';
    ws.getCell(6, 1).font = { size: 12, bold: true };
    ws.getRow(6).height = 20;

    const status = String(inv?.status ?? '').trim();
    const stockDate = String(this.daysheetDate ?? '').trim();
    const summaryHeaders = ['Daysheet Date', 'Status', 'Student Count', 'Employee Count', 'SubStaff Count', 'Others Count'];
    const summaryValues = [
      stockDate || '_',
      status || '_',
      Number(inv?.studentCount ?? 0),
      Number(inv?.employeeCount ?? 0),
      Number(inv?.subStaffCount ?? 0),
      Number(inv?.visitorsCount ?? 0),
    ];

    ws.getRow(8).values = summaryHeaders as any;
    ws.getRow(8).font = { bold: true };
    for (let c = 1; c <= summaryHeaders.length; c++) applyYellow(8, c);

    ws.getRow(9).values = summaryValues as any;
    for (let c = 1; c <= summaryHeaders.length; c++) applyYellow(9, c);

    const invHeader = [
      'S.No',
      'Item Name',
      'Open Balance',
      'Breakfast Qty',
      'Lunch Qty',
      'Snacks Qty',
      'Dinner Qty',
      'Total Qty',
      'Rate',
      'Fusion Id',
    ];

    let rowIdx = 11;

    const writeInventoryRows = (rows: any[], startIndex = 0): void => {
      rows.forEach((d: any, i: number) => {
        const bf = Number(d?.bfQty ?? 0);
        const lunch = Number(d?.lunchQty ?? 0);
        const snacks = Number(d?.snacksQty ?? 0);
        const dinner = Number(d?.dinnerQty ?? d?.DinnerQty ?? 0);
        const totalQty = d?.totalQty != null ? Number(d.totalQty) : bf + lunch + snacks + dinner;
        const row = ws.addRow([
          startIndex + i + 1,
          String(d?.itemNameEn ?? ''),
          Number(d?.onHandQty ?? d?.openBalance ?? 0),
          bf,
          lunch,
          snacks,
          dinner,
          totalQty,
          Number(d?.ratePerUnit ?? 0),
          String(d?.itemFusionId ?? ''),
        ]);
        applyBorder(row);
      });
    };

    if (scenarios.length) {
      // Today's Menu block
      ws.getCell(rowIdx, 1).value = "Today's Menu";
      ws.getCell(rowIdx, 1).font = { bold: true, size: 12 };
      rowIdx += 1;
      for (const menu of this.getTodaysMenuList()) {
        ws.getCell(rowIdx, 1).value = `${menu.scenarioName}: ${menu.menuItems} .`;
        rowIdx += 1;
      }
      rowIdx += 1;

      scenarios.forEach((scenario) => {
        const scenarioName = String(scenario?.scenarioName ?? 'Scenario');
        const menuCount = this.getScenarioMenuItemCount(scenario);
        ws.getCell(rowIdx, 1).value = `${scenarioName} (${menuCount})`;
        ws.getCell(rowIdx, 1).font = { bold: true };
        rowIdx += 1;

        const menuLabel = this.getScenarioMenuLabel(scenario);
        ws.getCell(rowIdx, 1).value = `Menu Items: ${menuLabel}`;
        rowIdx += 1;

        const invHeaderRow = ws.addRow(invHeader);
        invHeaderRow.font = { bold: true };
        applyBorder(invHeaderRow);

        const rows = Array.isArray(scenario?.saveInventoryBalanceDetails) ? scenario.saveInventoryBalanceDetails : [];
        writeInventoryRows(rows);
        rowIdx = (ws.lastRow?.number ?? rowIdx) + 2;
      });
    } else {
      ws.getCell(rowIdx, 1).value = 'saveInventoryBalanceDetails';
      ws.getCell(rowIdx, 1).font = { bold: true };
      rowIdx += 1;

      const invHeaderRow = ws.addRow(invHeader);
      invHeaderRow.font = { bold: true };
      applyBorder(invHeaderRow);
      writeInventoryRows(inventory);
    }

    ws.addRow([]);

    const supHeader = ['S.No', 'Campus', 'Students', 'Employees', 'SubStaff', 'Others'];
    ws.addRow(['supplyBuildings']).font = { bold: true };
    const supHeaderRow = ws.addRow(supHeader);
    supHeaderRow.font = { bold: true };
    applyBorder(supHeaderRow);

    supply.forEach((r: any, i: number) => {
      const row = ws.addRow([
        i + 1,
        String(r?.supplyBuildingName ?? ''),
        Number(r?.studentCount ?? 0),
        Number(r?.employeeCount ?? 0),
        Number(r?.subStaffCount ?? 0),
        Number(r?.visitorsCount ?? 0),
      ]);
      applyBorder(row);
    });

    ws.columns = [
      { width: 8 },
      { width: 40 },
      { width: 14 },
      { width: 14 },
      { width: 12 },
      { width: 12 },
      { width: 12 },
      { width: 12 },
      { width: 10 },
      { width: 16 },
    ];

    await this.protectExcelSheetReadOnly(ws);

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const fileName = `MessDaysheetClosed_${String(this.daysheetDate ?? '').replace(/\s+/g, '_') || 'export'}.xlsx`;
      fs.saveAs(blob, fileName);
    }).catch(() => {
      this.toast.showError('Excel export failed.');
    });
  }

  /** Lock sheet so exported Excel is view-only (select / filter still allowed). */
  private async protectExcelSheetReadOnly(ws: any): Promise<void> {
    if (!ws || typeof ws.protect !== 'function') {
      return;
    }
    try {
      await ws.protect('', {
        selectLockedCells: true,
        selectUnlockedCells: true,
        formatCells: false,
        formatColumns: false,
        formatRows: false,
        insertColumns: false,
        insertRows: false,
        insertHyperlinks: false,
        deleteColumns: false,
        deleteRows: false,
        sort: true,
        autoFilter: true,
        pivotTables: false,
      });
    } catch {
      /* protection is best-effort; still allow download */
    }
  }

  /** Loads the institution logo and anchors it at the top-left of the sheet. */
  private async addExcelLogo(workbook: Workbook, ws: any): Promise<void> {
    try {
      const response = await fetch(this.excelLogoPath);
      if (!response.ok) {
        return;
      }
      const buffer = await response.arrayBuffer();
      const imageId = workbook.addImage({
        buffer: buffer as any,
        extension: 'png',
      });
      ws.addImage(imageId, {
        tl: { col: 0, row: 0 },
        ext: { width: 70, height: 70 },
      });
    } catch {
      /* logo is optional; ignore load/render failures */
    }
  }

  /** Indian digit grouping (no currency symbol) */
  inrGroupedNumber(value: any): string {
    if (value === null || value === undefined || value === '') return '';
    const n = Number(String(value).replace(/,/g, ''));
    if (isNaN(n)) return '';
    return new Intl.NumberFormat('en-IN', {
      maximumFractionDigits: 2,
      minimumFractionDigits: 0,
    }).format(n);
  }

  backToMessDoDetails(): void {
    if (this.router.url.includes('MessDetails')) {
      this.service.clearMessExcelParams();
      this.service.setView('messClosedDetails');
      return;
    }
    this.router.navigate(['/messClosedDetails']);
  }
}
